import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Grid, GridSearchItem} from '../../../../shared/Models/grid';
import {ActionColumn, ActionItem, TextColumn} from '../../../../shared/Models/columns';
import * as moment from 'moment';
import {environment} from '../../../../../environments/environment';
import {TmsLogService} from '../../../Services/tms-log.service';
import {AuthenticationService} from '../../../../shared/Services/authentication.service';
import {NgbDateParserFormatter} from '@ng-bootstrap/ng-bootstrap';
import {NgbCountryDateParserFormatter} from '../../../../shared/Services/NgbCountryDateParserFormatter';
import {Router} from '@angular/router';

@Component({
  selector: 'app-tms-log',
  templateUrl: './tms-log.component.html',
  styleUrls: ['./tms-log.component.scss'],
  providers: [
    {provide: NgbDateParserFormatter, useClass: NgbCountryDateParserFormatter}
  ],
})
export class TmsLogComponent implements OnInit {

  public grid: Grid;
  public baseUrl = environment.apiUrl;
  @ViewChild('failRecordTemp', {static: true}) failRecordTemp;
  @ViewChild('downloadLink', {static: false}) downloadLink: ElementRef;

  constructor(private tmsLogService: TmsLogService, private auth: AuthenticationService, private router: Router) {
  }

  ngOnInit() {
    const dateFormat = this.auth.getDateFormat() + ' HH:mm';
    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.product.log.Last_updated',
          prop: 'created',
          sortable: false,
          type: TextColumn.type,
          translate: true,
          width: 100,
          valueFormatter: row => moment(row).format(dateFormat),
        },
        <TextColumn>{
          name: 'doctrine.product.log.total_records',
          prop: 'totalRecords',
          sortable: false,
          type: TextColumn.type,
          translate: true,
          width: 100,
        },
        <TextColumn>{
          name: 'doctrine.product.log.total_success_records',
          prop: 'totalSuccessRecords',
          sortable: false,
          type: TextColumn.type,
          translate: true,
          width: 100,
        },
        <TextColumn>{
          name: 'doctrine.product.log.total_fail_records',
          prop: 'totalFailsRecords',
          sortable: false,
          type: TextColumn.type,
          translate: true,
          width: 100,
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          width: 100,
          actionItems: [
            <ActionItem>{
              icon: 'feather icon-download',
              tooltip: 'global.download_file',
              onclick: row => {
                const el: HTMLElement = this.downloadLink.nativeElement as HTMLElement;
                el.setAttribute('href', this.baseUrl + '/download?path=' + row.mainFile.path
                  + '&filename=' + row.mainFile.filename);
                el.setAttribute('download', row.mainFile.filename);
                el.click();
              },
              showCallback: row => row,
              btnClass: 'ripple light ms-1'
            },
            <ActionItem>{
              icon: 'fa fa-file-text-o fa-lg',
              tooltip: 'global.view_log',
              onclick: row => {
                const el: HTMLElement = this.downloadLink.nativeElement as HTMLElement;
                el.setAttribute('href', this.baseUrl + '/download?path=' + row.logFile.path
                  + '&filename=' + row.logFile.filename);
                el.setAttribute('download', row.logFile.filename);
                el.click();
              },
              showCallback: row => row,
              btnClass: 'ripple light ms-1'
            },
          ]
        }
      ],
      service: this.tmsLogService,
      rememberURL: this.router.url,
      method: 'getTmsLog',
      defaultSort: 'created',
      doseNotHaveSearch: true,
      search: [
        <GridSearchItem>{
          calendarFromDate: 'from',
          calendarToDate: 'to',
          hasCalendar: true,
        }
      ],
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'desc',
      showButton: true,
    };
  }

}
